import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
  Link,
  Backdrop,
  LinearProgress,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  getBusinessName,
  getCarrier,
  registerCarrier,
} from "../redux/action/carrier";
import { unwrapResult } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginCarrier } from "../redux/action/carrier";
import { jwtDecode } from "jwt-decode";
import { setTheme } from "../redux/reducers/themeSlice";

const RegisterCarrier: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [businessName, setBusinessName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const options = [
    "Text Msg Image Conversion Tool",
    "Chatbot Booking Agent and AI Customer Support Bot (all-in-one)",
    "SMS Tool and Booking Chatbot",
  ];
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  const handleSelect = (option: string) => {
    setSelectedOption((prev) => (prev === option ? null : option)); // toggle selection
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showStripeButton, setShowStripeButton] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [stripeSessionUrl, setStripeSessionUrl] = useState("");
  const [loadingMessage, setLoadingMessage] = useState("");
 
  const handleSubmit = () => {
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setError("");
    setIsLoading(true);
    setLoadingMessage("Creating Your Account...");
    const formattedBusinessName = formatBusinessName(businessName);
    const carrierData = {
      business_name: formattedBusinessName,
      email,
      password,
      // isBookingTool:
      //   selectedOption ===
      //     "Chatbot Booking Agent and AI Customer Support Bot (all-in-one)" ||
      //   selectedOption === "SMS Tool and Booking Chatbot"
      //     ? true
      //     : false,
      // isSmsTool:
      //   selectedOption === "Text Msg Image Conversion Tool" ||
      //   selectedOption === "SMS Tool and Booking Chatbot"
      //     ? true
      //     : false,
      // isComboSubscription: selectedOption === "SMS Tool and Booking Chatbot",
    };

    dispatch<any>(registerCarrier(carrierData))
      .then(unwrapResult)
      .then(async (jwtToken: any) => {
        console.log(jwtToken);
        setIsLoading(false);
        // navigate(`/login-carrier`);
        if (jwtToken) {
          localStorage.setItem("jwtToken", jwtToken);
          const decoded: any = jwtDecode(jwtToken);
          const role = decoded.role;
          localStorage.setItem("role", role);
        }
        const businessNameResponse = await dispatch<any>(
          getBusinessName(email)
        );
        const businessName = unwrapResult(businessNameResponse);
        const formattedBusinessName = formatBusinessName(businessName);

        if (formattedBusinessName) {
          localStorage.setItem("businessName", formattedBusinessName);
          localStorage.setItem("email", email);
          dispatch<any>(getCarrier(email))
            .then(unwrapResult)
            .then((res: any) => {
              const colorHex = res.color_hex;
              dispatch(
                setTheme({ primaryColor: colorHex, secondaryColor: "#4A90E2" })
              );
              setIsLoading(false);
              navigate(
                `/${encodeURIComponent(formattedBusinessName)}/dashboard`
              );
            });
          // if (res.url) {
          // setStripeSessionUrl(res.url);
          // setShowStripeButton(true);
          // window.location.href = res.url;
          // }
          // const loginData = { email, password };
          // dispatch<any>(loginCarrier(loginData))
          //   .then(unwrapResult)
          //   .then((jwtToken: any) => {
          //     if (jwtToken) {
          //       localStorage.setItem("jwtToken", jwtToken);
          //       localStorage.setItem("email", email);
          //       localStorage.setItem("businessName", formattedBusinessName);
          //       const decoded: any = jwtDecode(jwtToken);
          //       const role = decoded.role;
          //       localStorage.setItem("role", role);
          //       navigate(`/${encodeURIComponent(formattedBusinessName)}/dashboard`);
          //     }
          //   })
          //   .catch((err: any) => {
          //     setError(err?.message || "Login failed. Please try again.");
          //   });
        }
      })
      .catch((err: any) => {
        setError("Account already exists with this email / business name.");
        setIsLoading(false);
      });
  };

  const formatBusinessName = (name: string): string => {
    return name
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]/g, "");
  };

  const goToStripeOnboarding = () => {
    setLoadingMessage("Redirecting To Stripe...");
    setIsLoading(true);
    setTimeout(() => {
      window.location.href = stripeSessionUrl;
    });
  };

  const isFormValid =
    businessName.trim() &&
    email.trim() &&
    password &&
    confirmPassword &&
    password === confirmPassword;

  return (
    <>
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          height: "100%",
          background:
            "linear-gradient(-45deg, #ee7752, #e73c7e, #23d5ab, #23a6d5)",
          backgroundSize: "400% 400%",
          animation: "gradientAnimation 20s ease infinite",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: isMobile ? 1 : 3,
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            maxWidth: 500,
            width: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 3,
            p: isMobile ? 2 : 3,
            mx: isMobile ? 1 : 3,
            textAlign: "center",
            position: "relative",
            zIndex: 1,
            overflowY: "auto",
            maxHeight: "90vh",
            boxSizing: "border-box",
          }}
        >
          {isLoading && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isLoading}
              onClick={() => setIsLoading(false)}
            >
              <Box sx={{ width: "50%", textAlign: "center" }}>
                <LinearProgress />
                <Typography fontSize={16} fontWeight={500} mt={1}>
                  {loadingMessage}
                </Typography>
              </Box>
            </Backdrop>
          )}

          <Typography
            variant={isMobile ? "h5" : "h4"}
            gutterBottom
            sx={{
              mb: 3,
              fontWeight: "bold",
              opacity: 0,
              animation: "fadeSlideIn 1s ease forwards",
              "@keyframes fadeSlideIn": {
                "0%": { opacity: 0, transform: "translateY(20px)" },
                "100%": { opacity: 1, transform: "translateY(0)" },
              },
            }}
          >
            Sign up to{" "}
            <Box
              component="span"
              sx={{
                fontFamily: "'Courier New', Courier, monospace", // example font style
                color: "#1976d2", // example blue color
                fontWeight: "bold",
              }}
            >
              AI of Moving
            </Box>
          </Typography>

          <TextField
            fullWidth
            label="Business Name"
            variant="outlined"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />

          <TextField
            fullWidth
            label="Confirm Password"
            variant="outlined"
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  edge="end"
                  aria-label={
                    showConfirmPassword
                      ? "Hide confirm password"
                      : "Show confirm password"
                  }
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />

          {error && (
            <Typography
              color="error"
              sx={{ mb: 2, fontWeight: 500 }}
              role="alert"
              aria-live="assertive"
            >
              {error}
            </Typography>
          )}

          {!showStripeButton ? (
            <Stack spacing={3}>
              {/* <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              justifyContent: "center",
              mb: 1,
            }}
          >
            {options.map((option) => {
              const selected = selectedOption === option;
              return (
                <button
                  key={option}
                  onClick={() => handleSelect(option)}
                  style={{
                    padding: "10px 20px",
                    borderRadius: 24,
                    border: selected ? "2px solid #2563EB" : "1px solid #ccc",
                    backgroundColor: selected ? "#3B82F6" : "#F3F4F6",
                    color: selected ? "white" : "#111827",
                    cursor: "pointer",
                    userSelect: "none",
                    fontWeight: 600,
                    fontSize: 14,
                    boxShadow: selected
                      ? "0 4px 12px rgba(59, 130, 246, 0.4)"
                      : "none",
                    transform: selected ? "scale(1.05)" : "scale(1)",
                    transition: "all 0.25s ease",
                    minWidth: 260,
                    textAlign: "center",
                    outline: "none",
                  }}
                  aria-pressed={selected}
                  type="button"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleSelect(option);
                    }
                  }}
                >
                  {option}
                </button>
              );
            })}
          </Box> */}

              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                sx={{
                  width: "100%",
                  fontWeight: "bold",
                  fontSize: 16,
                  py: 1.5,
                  opacity: isFormValid ? 1 : 0.6,
                  pointerEvents: isFormValid ? "auto" : "none",
                  transition: "opacity 0.3s ease",
                }}
                disabled={!isFormValid}
              >
                Register
              </Button>
            </Stack>
          ) : (
            <Button
              variant="contained"
              color="success"
              onClick={goToStripeOnboarding}
              sx={{ width: "100%", fontWeight: "bold", fontSize: 16, py: 1.5 }}
            >
              Start Stripe Onboarding
            </Button>
          )}

          <Box sx={{ mt: 3, textAlign: "center" }}>
            <Typography variant="body2">
              Already have an account?
              <Link
                href="/login-carrier"
                variant="body2"
                sx={{ textDecoration: "none", color: "primary.main", ml: 1 }}
              >
                Login
              </Link>
            </Typography>
          </Box>
        </Box>
      </Box>
      <style>
        {`
          @keyframes gradientAnimation {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }
        `}
      </style>
    </>
  );
};

export default RegisterCarrier;
